import { Link, NavLink } from "react-router-dom";
import { Plus, HardDrive } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useProjects } from "@/hooks/use-projects";
import { STATUS_DOT_CLASSES } from "@/components/scan/ScanStatusBadge";
import { cn } from "@/lib/utils";

export function Sidebar() {

    const projects = useProjects();
    const items = projects.data?.data ?? [];

    return (
        <aside className="w-64 shrink-0 border-r bg-muted/40 flex flex-col">
            <div className="p-4 border-b">
                <Link to="/projects" className="font-semibold">Site Migrator</Link>
            </div>
            <nav className="flex-1 overflow-y-auto p-2 space-y-1">
                {projects.isLoading
                    ? (
                        <p className="text-sm text-muted-foreground px-3 py-2">Loading…</p>
                    )
                    : items.length > 0
                        ? items.map((p) => (
                            <NavLink
                                key={p.id}
                                to={`/projects/${p.id}`}
                                className={({ isActive }) =>
                                    cn(
                                        "flex items-center gap-2 rounded-md px-3 py-[var(--nav-item-py)] text-sm",
                                        isActive ? "bg-accent text-accent-foreground" : "hover:bg-accent/50",
                                    )
                                }
                                end
                            >
                                <span
                                    className={cn(
                                        "size-2 rounded-full shrink-0",
                                        p.latest_scan ? STATUS_DOT_CLASSES[p.latest_scan.status] : "bg-muted-foreground/30",
                                    )}
                                    aria-label={p.latest_scan ? `Latest scan: ${p.latest_scan.status}` : "No scans"}
                                />
                                <span className="truncate">{p.name}</span>
                            </NavLink>
                        ))
                        : (
                            <p className="text-sm text-muted-foreground px-3 py-2">No projects yet.</p>
                        )}
            </nav>
            <div className="border-t p-2">
                <NavLink
                    to="/storage"
                    className={({ isActive }) =>
                        cn(
                            "flex items-center gap-2 rounded-md px-3 py-2 text-sm",
                            isActive ? "bg-accent text-accent-foreground" : "hover:bg-accent/50",
                        )
                    }
                >
                    <HardDrive className="size-4" aria-hidden />
                    Storage
                </NavLink>
            </div>
            <div className="p-2 border-t">
                <Button asChild variant="default" className="w-full">
                    <Link to="/projects/new">
                        <Plus />
                        New project
                    </Link>
                </Button>
            </div>
        </aside>
    );
}
